import { render, staticRenderFns } from "./LoadMore.vue?vue&type=template&id=453f2296&scoped=true&"
import script from "./LoadMore.vue?vue&type=script&lang=ts&"
export * from "./LoadMore.vue?vue&type=script&lang=ts&"
import style0 from "./LoadMore.vue?vue&type=style&index=0&id=453f2296&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f2296",
  null
  
)

export default component.exports